import Vue from 'vue'
import Community from './Community.vue'
import MapResults from './MapResults.vue'
import ContentViewer from './ContentViewer.vue'
import {getDocumentData} from '../client'

const user = getDocumentData("user-data");

if (document.getElementById("community")) {
    const data = getDocumentData("community-data");
    new Vue({
        render: h => h(Community, {
            props: data
        })
    }).$mount('#community');
}
else if (document.getElementById("map-results")) {
    const data = getDocumentData("map-results-data");
    const city = getDocumentData("city-data");
    const filters = getDocumentData("filters-data");


    new Vue({
      render: h => h(MapResults, {
          props: {
              "result": data,
              "city": city,
              "username": user? user.username : null,
              "filters": filters
          }
      })
    }).$mount('#map-results');
}
else if (document.getElementById("blog_post_content")) {
    const blog_data = getDocumentData("blog_post-data")

    new Vue({
      render: h => h(ContentViewer, {
          props: {
              "blog_data": blog_data,
              "username": user? user.username : null,
              "public_view": true
          }
      })
    }).$mount('#blog_post_content');
}
